import { TRIGGER_TYPES } from 'constants/MeshbotConstant';
import { NOT_NAME } from 'containers/Ezlo/EzloMeshbot/constants';
import { getMethodName } from 'containers/Ezlo/EzloMeshbot/utils';

/**
 * Determines whether a given method name represents an "isDictionaryChanged" trigger,
 * including cases where it is wrapped in a `not` operator.
 *
 * @param {string} name - The name of the method (e.g., 'isDictionaryChanged', 'not').
 * @param {Object} block - The trigger block to inspect (used when `name === 'not'`).
 * @param {Array} [block.fields] - The fields array containing nested trigger blocks.
 * @returns {boolean} True if the method or its wrapped method is "isDictionaryChanged".
 *
 * @example
 * isDictionaryChangedMethod('isDictionaryChanged', {}); // true
 * isDictionaryChangedMethod('not', { fields: [{ value: { blockOptions: { method: { name: 'isDictionaryChanged' }}}}] }); // true
 */
export const isDictionaryChangedMethod = (name, block) =>
    name === TRIGGER_TYPES.IS_DICTIONARY_CHANGED ||
    (name === NOT_NAME &&
        getMethodName(block?.fields?.[0]?.value?.blockOptions) === TRIGGER_TYPES.IS_DICTIONARY_CHANGED);
